import Nav from "../../Nav";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import blog1 from "../images/photo1.jpg";
import blog2 from "../images/photo2.jpg";
import blog3 from "../images/photo3.jpg";
import blog4 from "../images/photo4_2.svg";
import blog5 from "../images/photo5.jpg";
import blog6 from "../images/photo6.jpg";
import blog7 from "../images/photo7.jpg";
import Aos from "aos";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const blog = [
  {
    id: 1,
    image: blog1,
    title: "I need to use English at my new job",
    routingTitle:"pronunciation/I_need_to_use_English_at_my_new_job",
    description:
      "I couldn’t believe it when I was invited for the job interview. Just imagine my surprise ....",
    date: "7 June, 2024",
  },
  {
    id: 2,
    image: blog2,
    routingTitle:"pronunciation/Do_you_often_misunderstand_native_speakers?",
    title: "Do you often misunderstand native speakers?",
    description:
      "Improving listening skills in English as a second language relies on recognizing and ....",
    date: "7 June, 2024",
  },
  {
    id: 3,
    image: blog3,
    routingTitle:"pronunciation/Common_Challenges_for_French_Speakers_in_English_Pronunciation",
    title: "Common Challenges for French Speakers in English Pronunciation",
    description:
      "English and French language originate from different families of languages. This simply means....",
    date: "7 June, 2024",
  },
  {
    id: 4,
    image: blog4,
    routingTitle:"pronunciation/Spanish_People_Struggle_with_English_Pronunciation",
    title: "Spanish People Struggle with English Pronunciation",
    description:
      "Spanish and English have some similarities in pronunciation, but there are also notable ....",
    date: "7 June, 2024",
  },
];

const blogmain = [
  {
    id: 5,
    image: blog5,
    routingTitle:"pronunciation",
    title: "Pronunciation Blog",
    description: "",
    date: "7 June, 2024",
  },
  {
    id: 6,
    image: blog6,
    routingTitle:"Grammar",
    title: "Grammar Blog",
    description: "",
    date: "7 June, 2024",
  },
  {
    id: 7,
    image: blog7,
    routingTitle:"motivational",
    title: "Other Articles",
    description: "",
    date: "7 June, 2024",
  },
];

const Blog = () => {
  const navigate = useNavigate();

  const handleNavigation = (routingTitle, e) => {
    e.preventDefault();
    navigate(`/blog/${routingTitle}`);
  };

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const cardStyles = {
    position: "relative",
    overflow: "hidden",
    borderRadius: 4,
    transition: "transform 0.2s",
    height: { xs: "auto", md: "450px" },
    boxShadow: "0 0 15px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      transform: "scale(1.05)",
      cursor: "pointer",
    },
  };

  const additionalCardStyles = (id) => ({
    display: "flex",
    alignItems: "center",
    padding: { xs: 1, sm: 2 },
    backgroundColor: "#ffffff",
    borderRadius: 2,
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    borderRight: id === 5 ? "5px solid #80ffed" : "none",
  });

  const cardMediaStyles = {
    width: { xs: 80, sm: 100 },
    marginRight: 2,
    transition: "transform 0.2s",
    "&:hover": {
      transform: "scale(1.1)",
      cursor: "pointer",
    },
    padding: "5px",
    height: { xs: "60px", sm: "80px" },
    boxSizing: "border-box",
  };

  return (
    <>
      <Nav />
      <Box
        sx={{
          backgroundColor: "#ffffff",
          py: 8,
          fontFamily: "Arial, sans-serif",
        }}
      >
        <Box
          sx={{
            py: { xs: 8, sm: 15 },
            textAlign: "center",
            color: "#000000",
            backgroundColor: "#f8fafc",
          }}
        >
          <Container maxWidth="lg">
            <Typography
              variant="h2"
              align="center"
              className="merriweather-bold"
              gutterBottom
              sx={{
                fontWeight: "bold",
                fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
              }}
            >
              Blog
            </Typography>
            {/* Decorative Images */}
            <div id="image-container" className="absolute top-20 left-0">
              <img
                src="https://demo.edublink.co/wp-content/uploads/2023/05/shape-13.png"
                className="ml-4 mt-4"
                alt="Small Image"
              />
            </div>
          </Container>
        </Box>
        <Container
          maxWidth="lg"
          sx={{
            backgroundColor: "#ffffff",
            p: { xs: 2, sm: 5 },
            borderRadius: 2,
            mt: { xs: -4, sm: -8 },
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
              <Typography
                variant="h4"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  mb: 4,
                  fontSize: { xs: "1.25rem", sm: "1.5rem", md: "2rem" },
                }}
              >
                Pronunciation Blog
              </Typography>
              <Grid container spacing={4}>
                {blog.map((blog, index) => (
                  <Grid item xs={12} sm={6} key={blog.id}>
                    <Card
                      data-aos="fade-up"
                      sx={cardStyles}
                      onClick={(e) => handleNavigation(blog.routingTitle, e)}
                    >
                      <CardMedia
                        component="img"
                        className="card-image"
                        height="250"
                        image={blog.image}
                        alt={blog.title}
                        sx={{
                          transition: "transform 0.2s",
                          "&:hover": { transform: "scale(1.1)" },
                        }}
                      />
                      <CardContent>
                        <Typography
                          gutterBottom
                          variant="h5"
                          component="div"
                          sx={{
                            fontWeight: "bold",
                            fontSize: { xs: "1rem", sm: "1.25rem" },
                          }}
                        >
                          {blog.title}
                        </Typography>
                        <Box
                          sx={{ display: "flex", alignItems: "center", mb: 2 }}
                        >
                          <CalendarTodayIcon sx={{ fontSize: 14, mr: 1 }} />
                          <Typography variant="body2" color="text.secondary">
                            {blog.date}
                          </Typography>
                        </Box>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          dangerouslySetInnerHTML={{ __html: blog.description }}
                        />
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  p: { xs: 2, sm: 3 },
                  backgroundColor: "#f8fafc",
                  borderRadius: 2,
                  boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                  position: { md: "sticky" },
                  top: "80px",
                  maxHeight: { md: "calc(100vh - 120px)" },
                  overflowY: { md: "auto" },
                }}
              >
                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{
                    fontWeight: "bold",
                    mb: 4,
                    fontSize: { xs: "1.25rem", sm: "1.5rem" },
                  }}
                >
                  Additional Blogs
                </Typography>
                <Grid container direction="column" spacing={4}>
                  {blogmain.slice(0, 3).map((blog) => (
                    <Grid item key={blog.id}>
                      <Card
                        sx={additionalCardStyles(blog.id)}
                        onClick={(e) => handleNavigation(blog.routingTitle, e)}
                      >
                        <CardMedia
                          component="img"
                          className="card-image"
                          height="150"
                          image={blog.image}
                          alt={blog.title}
                          sx={cardMediaStyles}
                        />
                        <CardContent sx={{ p: 0 }}>
                          <Typography
                            gutterBottom
                            variant="h6"
                            component="div"
                            sx={{
                              fontWeight: "bold",
                              fontSize: { xs: "0.9rem", sm: "1.1rem" },
                            }}
                          >
                            {blog.title}
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mb: 2,
                            }}
                          >
                            <CalendarTodayIcon sx={{ fontSize: 14, mr: 1 }} />
                            <Typography variant="body2" color="text.secondary">
                              {blog.date}
                            </Typography>
                          </Box>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            dangerouslySetInnerHTML={{
                              __html: blog.description,
                            }}
                          />
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Blog;
